export default __webpack_public_path__ + "static/media/space_back.6e8a9a9b.jpg";